import { ShieldCheck, Stethoscope, Users } from "lucide-react";
import RatingBadge from "@/components/np/RatingBadge";
import { site } from "@/content";

const ITEMS = [
  { icon: Stethoscope, title: "Legitimerad läkare", text: "Alla behandlingar utförs av läkare" },
  { icon: Users, title: "Medlem i Svenska Smärtläkarföreningen", text: "och Swedish Pain Society" },
  { icon: ShieldCheck, title: site.noReferral, text: "Boka direkt via BokaDirekt" },
];

export default function TrustStrip() {
  return (
    <section aria-label="Förtroende" className="border-b border-line bg-sage/35">
      <div className="container-np grid items-center gap-6 py-8 pt-12 lg:grid-cols-[auto_1fr] lg:gap-12 lg:pt-8">
        <RatingBadge />
        <ul className="grid gap-5 sm:grid-cols-3">
          {ITEMS.map(({ icon: Icon, title, text }) => (
            <li key={title} className="flex gap-3">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest" aria-hidden="true" />
              <span>
                <span className="block text-sm font-semibold text-ink">{title}</span>
                <span className="block text-sm text-muted">{text}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
